module.exports = __webpack_public_path__ + "img/couples-068.0dc86d63.jpg";